<div class="map-page">
  <div class="map-container">
    <map-drawer #lytxDrawer
                class="working-list-drawer"
                [width]="drawerWidth"
                [data]="geofenceActivations"
                [mapEvent]="mapEvent"
                (onFilter)="filterResults($event)"
                (onItemSelected)="selectItem($event)">
    </map-drawer>
    <google-maps-wrapper #map
                         [center]="center"
                         [radius]="radius"
                         [bounds]="bounds"
                         [styles]="styles"
                         [geofenceActivations]="geofenceActivations"
                         [geofence]="geofence"
                         (onMarkerClick)="onMarkerClick($event)"
                         (onMapZoom)="onMapZoom($event)"
                         (onMapClick)="onMapClick($event)"
                         (onMapReady)="onMapReady($event)">
    </google-maps-wrapper>
  </div>
</div>
